import { colors } from './_colors';
import { textStyles } from './_textStyles';
import { borderRadius } from './_borderRadius';
import { spacing } from './_spacing';
import { elevations } from './_elevations';
import { opacities } from './_opacities';
import { breakpoints } from './_breakpoints';

const theme = {
  breakpoints,
  colors,
  textStyles,
  borderRadius,
  spacing,
  elevations,
  opacities,
};

export default theme;
